import { createAsyncThunk } from '@reduxjs/toolkit';
import httpService from './httpService';

export const getSearchData: any = createAsyncThunk<any>(
	'getSearchData',
	async (data: any) => {
		const response = await httpService.get(`common/search-users`, {
			params:
				data?.type == 'MOBILE'
					? {
							type: data && data?.type,
							mobileNumber: data && data?.mobileNumber,
							countryCode: '%2B' + data && data?.countryCode
					  }
					: {
							type: data && data?.type,
							email: data && data?.email
					  }
		});
		return response.data.data;
	}
);
